export default __webpack_public_path__ + "static/media/cumprimento.eac4f8c6.svg";